
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { CompanyService } from "@/services/company-service";
import { CompanyDossierService } from "@/services/company-dossier-service";
import "codemirror/mode/javascript/javascript";
import { BrowseExtraButton } from "@/models/browse-extra-button";
import { BrowseExtraButtonService } from "@/services/browse-extra-button-service";
import AppDossierBrowseExtraButtonEditProperties from "@/components/dossier/DossierBrowseExtraButtonEditProperties.vue";

export default Vue.extend({
	data(){
		return {
			company: new Company(),
			dossier: new Dossier(),
			button: new BrowseExtraButton(),
			ready: false,
			propertyEditorOpen: false,
		};
	},
	computed: {
		cmOptions():any{
			return {
				mode: "text/javascript"
			};
		},
	},
	methods: {
		goToDossier(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.dossier.id}/edit`);
		},
		async save(){
			if (this.button.ID == 0){
				this.button = await BrowseExtraButtonService.createButton(this.dossier.id, this.button);
			}else{
				this.button = await BrowseExtraButtonService.editButton(this.dossier.id, this.button);
			}
			this.$wf.notify("Changes saved", "success", 3000, "check");
		},
		editProperties(){
			this.propertyEditorOpen = true;
		},
	},
	async created(){
		let companyId = parseInt(this.$route.params.companyId);
		let dossierId = parseInt(this.$route.params.dossierId);
		this.company = await CompanyService.getCompany(companyId);
		this.dossier = await CompanyDossierService.getDossier(companyId, dossierId);
		let buttonId = parseInt(this.$route.params.buttonId || "0");
		if (buttonId != 0){
			this.button = await BrowseExtraButtonService.getButton(this.dossier.id, buttonId);
		}
		this.ready = true;
	},
	components: {
		AppDossierBrowseExtraButtonEditProperties
	}
});
